// Real values for the dfendpoc project. This file is imported by BOTH
// admin.ts (server, only needs databaseURL/storageBucket alongside the
// service account cert) and web.ts (client, needs the full web app config
// below) — a superset covering both, not two separate files, since that's
// how the existing import structure is wired.
//
// databaseURL/storageBucket confirmed Aug 7, 2026 via the Firebase
// Management API and `gcloud storage buckets list`. The rest (apiKey,
// projectId, appId, messagingSenderId, measurementId) added Aug 7, 2026,
// pulled directly from the registered "DFend POC" web app via
// `firebase apps:sdkconfig WEB 1:244180298306:web:d16bab6fe083704bfb5bdb
// --project=dfendpoc` — not guessed. Without these, web.ts's
// initializeApp(config) throws "projectId not provided in
// firebase.initializeApp" (and would equally fail on any of the others
// being missing) since the client SDK needs the full config object, not
// just the subset the Admin SDK happens to need.
//
// authDomain is DELIBERATELY NOT the sdkconfig default
// (dfendpoc.firebaseapp.com) — corrected same day after Google Sign-In
// failed with redirect_uri_mismatch. The Google OAuth client's only
// pre-existing (previously-working) authorized redirect URI was
// login.dfend.app's /__/auth/handler, which could only have ever worked
// if the app was actually initialized with this custom authDomain —
// Firebase's SDK derives the OAuth redirect URI directly from authDomain,
// independent of whatever page the user is actually on. login.dfend.app
// is a verified custom domain on the same Hosting site as
// dashboard.dfend.app and correctly serves the Firebase auth handler.
//
// Gitignored (config/**/private) — never commit this file's sibling
// serviceAccountKey.json. This file itself is lower-risk (a Firebase web
// apiKey is not a secret — it's meant to be public, security comes from
// Firestore/Auth rules, not from hiding this value) but has no reason to
// be tracked either, so it stays alongside the real secret for simplicity.
module.exports = {
  apiKey: 'AIzaSyBGSDEwIa4jj1vbkYvvTQUxVjLUa0d-tPk',
  authDomain: 'login.dfend.app',
  databaseURL: 'https://dfendpoc-default-rtdb.firebaseio.com',
  projectId: 'dfendpoc',
  storageBucket: 'dfendpoc.appspot.com',
  messagingSenderId: '244180298306',
  appId: '1:244180298306:web:d16bab6fe083704bfb5bdb',
  measurementId: 'G-XZH4M3W81Z'
};
